import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'DataItem' })({
    collapse: {
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        padding: 8,
        boxSizing: 'border-box'
    },
    label: {
        borderRadius: 8,
        background: '#F8F8F8'
    },
    parts: {
        display: 'flex',
        flexDirection: 'column'
    },
    part: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        padding: '12px 0',

        ['&:not(:only-child)']: {
            borderBottom: '1px solid #ECECEC'
        }
    },
    partLabel: {
        color: '#8E8E8E',
        fontSize: 13,
        fontWeight: 500,
        lineHeight: '150%',
        flex: 1
    },
    partValue: {
        color: '#232323',
        fontSize: 13,
        fontWeight: 600,
        lineHeight: '150%',
        flex: 1,
        '&::first-letter': {
            textTransform: 'uppercase'
        },
        textTransform: 'lowercase'
    },
    vector: {
        display: 'flex',
        alignItems: 'center',
        padding: 4,
        borderRadius: 8,
        border: '1px solid #ECECEC'
    },
    vectorValue: {
        color: '#232323',
        fontSize: 12,
        fontWeight: 500,
        lineHeight: '150%',
        letterSpacing: -0.2,
        flex: 1,
        textOverflow: 'ellipsis',
        display: 'block',
        overflow: 'hidden'
    }
});
